import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Card from '../../layout/Card';
import ModuleHome from '../../layout/ModuleHome';
import { breadcrumbsPropTypes } from '../../common/resource/proptypes/CommonPropTypes';

const FoodHome = ({ cards, breadcrumbs }) => (
  <ModuleHome
    title="Alimentación"
    text="Éste es el módulo de Alimentación."
    cards={cards}
    breadcrumbs={breadcrumbs}
  />
);

const mapStateToProps = ({ FoodUnit }) => ({
  cards: FoodUnit.UnitHome.get('cards'),
  breadcrumbs: FoodUnit.UnitHome.get('breadcrumbs'),
});

FoodHome.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cards: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)).isRequired,
};

export default connect(mapStateToProps)(FoodHome);
